import { Controller } from "@hotwired/stimulus"

// "Generate with AI" button (gap feature #4): asks the ai_content endpoint
// for variants, shows them as clickable suggestions, and inserts the chosen
// one into the target textarea (recording acceptance for metrics).
export default class extends Controller {
  static targets = ["topic", "output", "variants", "button"]
  static values = { url: String, promptKind: String, sourceSurface: String }

  async generate(event) {
    event.preventDefault()
    const topic = this.topicTarget.value.trim()
    if (!topic) { this.topicTarget.focus(); return }

    this.buttonTarget.disabled = true
    this.variantsTarget.innerHTML = `<p class="text-sm text-gray-500">${this.buttonTarget.dataset.loadingText || "…"}</p>`
    this.variantsTarget.classList.remove("hidden")

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
        },
        body: JSON.stringify({
          prompt_kind: this.promptKindValue,
          source_surface: this.sourceSurfaceValue,
          topic: topic,
          goal: topic
        })
      })

      const data = await response.json()
      if (!response.ok) throw new Error(data.error || response.statusText)

      this.renderVariants(data.id, data.variants)
    } catch (error) {
      this.variantsTarget.innerHTML = `<p class="text-sm text-red-600">${error.message}</p>`
    } finally {
      this.buttonTarget.disabled = false
    }
  }

  renderVariants(recordId, variants) {
    this.variantsTarget.innerHTML = ""
    variants.forEach((variant, index) => {
      const card = document.createElement("button")
      card.type = "button"
      card.className = "owner-setup-card w-full text-left"
      card.innerHTML = `<span class="owner-setup-card-description block whitespace-pre-line"></span>`
      card.querySelector("span").textContent = variant
      card.addEventListener("click", () => this.accept(recordId, index, variant))
      this.variantsTarget.appendChild(card)
    })
  }

  accept(recordId, index, variant) {
    // Respect the textarea's maxlength (JS value assignment bypasses it)
    const max = parseInt(this.outputTarget.getAttribute("maxlength"), 10)
    this.outputTarget.value = Number.isFinite(max) && max > 0 ? variant.slice(0, max) : variant
    this.outputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.variantsTarget.classList.add("hidden")

    fetch(`${this.urlValue}/${recordId}/accept`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
      },
      body: JSON.stringify({ variant: index })
    }).catch(() => {})
  }
}
